import {YiiUrlFactory} from "../backends/YiiRoutes";
import {useStores} from "../stores/useStores";

export function useMainUrl() {
    const {organizationStore, i18nStore} = useStores();

    return YiiUrlFactory(
        organizationStore.organization.json_data?.settings?.appearance?.showWelcomePage ? "/?showHomepage=true" : "/",
        i18nStore.currentOrgSupportedLocale
    );
}